export default __webpack_public_path__ + "static/media/FiraSansExtraCondensed-Bold.ccf2525f.ttf";